import apiInstance from '@/api';
import { ThunkApiConfig } from '@/models/ThunkApiConfig';
import { RootState } from '@/store/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { WipStatusOption } from '../types';

export interface WipStatusesState {
  options: WipStatusOption[];
  loading: boolean;
  loaded: boolean;
}

const initialState: WipStatusesState = {
  options: [],
  loading: false,
  loaded: false,
};

export const fetchWipStatuses = createAsyncThunk.withTypes<ThunkApiConfig>()(
  'wipStatuses/fetch',
  async () => {
    const response = await apiInstance.deals.getWipStatuses();
    return response.data.data;
  },
  // the list is static reference data: fetch once per session
  { condition: (_, { getState }) => !getState().wipStatuses.loaded },
);

const wipStatusesSlice = createSlice({
  name: 'wipStatuses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWipStatuses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWipStatuses.fulfilled, (state, action) => {
        state.options = action.payload;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(fetchWipStatuses.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const selectWipStatuses = (state: RootState) =>
  state.wipStatuses.options;
export const selectWipStatusesLoading = (state: RootState) =>
  state.wipStatuses.loading;

export default wipStatusesSlice.reducer;
